import React, { useState } from 'react'

import { Layout, Menu } from 'antd';
import {
    FileDoneOutlined, LogoutOutlined, SettingOutlined
} from '@ant-design/icons';
import { Link } from "react-router-dom";

import '../css/Menu.css'
import { Toaster } from 'react-hot-toast';
import { useLoginStore } from '../stores/useLoginStore';
import { sin_editar } from '../data/datos';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const MenuPrincipal = ({ componente }) => {

    const [collapsed, setCollapsed] = useState(false)
    const onCollapse = collapsed => {
        setCollapsed( collapsed );
    };
    const objLogueado = useLoginStore( store => store.objLogueado )
    const { email } = useLoginStore( store => store.objLogueado )
    let mostrarBtn = !sin_editar.includes( email )

    const elegirSubmenu = () => {

        if ( objLogueado.nivel === 'ADMIN' ) {

            if ( mostrarBtn ) {
                return (
                    <SubMenu key="sub" icon={<FileDoneOutlined />} className='no-select' title="Examen">

                        <Menu.Item key="1" className='no-select'>
                            <Link to='/subir-datos'>Subir datos</Link>
                        </Menu.Item>
                        <Menu.Item key="2" className='no-select'>
                            <Link to='/aspirantes'>Aspirantes</Link>
                        </Menu.Item>
                        <Menu.Item key="3" className='no-select'>
                            <Link to='/bachilleratos'>Bachilleratos</Link>
                        </Menu.Item>
                        <Menu.Item key="4" className='no-select'>
                            <Link to='/materias'>Materias</Link>
                        </Menu.Item>
                        <Menu.Item key="5" className='no-select'>
                            <Link to='/reportes'>Reportes</Link>
                        </Menu.Item>
                        <Menu.Item key="6" className='no-select'>
                            <Link to='/configuracion_aplicacion'>Configuración de aplicación</Link>
                        </Menu.Item>
                        <Menu.Item key="7" className='no-select'>
                            <Link to='/correos'>Correos</Link>
                        </Menu.Item>
                        <Menu.Item key="71" className='no-select'>
                            <Link to='/correos_enviados'>Correos enviados</Link>
                        </Menu.Item>
                        <Menu.Item key="8" className='no-select'>
                            <Link to='/inscribir_aspirante'>Inscribir aspirante</Link>
                        </Menu.Item>
                        <Menu.Item key="9" className='no-select'>
                            <Link to='/aspirantes_inscritos'>Aspirantes inscritos</Link>
                        </Menu.Item>
                    </SubMenu>
                )
            } else {
                return (
                    <SubMenu key="sub" icon={<FileDoneOutlined />} className='no-select' title="Examen">

                        <Menu.Item key="4" className='no-select'>
                            <Link to='/materias'>Materias</Link>
                        </Menu.Item>

                    </SubMenu>
                )
            }



        } else if ( objLogueado.nivel === 'COORDINADOR' ) {

            return (
                <SubMenu key="sub" icon={<FileDoneOutlined />} className='no-select' title="Reportes">

                    <Menu.Item key="6" className='no-select'>
                        <Link to='/coordinadores'>Carreras</Link>
                    </Menu.Item>

                </SubMenu>
            )

        }
    }

    return (
        <>
            <Layout style={{ minHeight: '100vh' }}>
                <Sider collapsible collapsed={collapsed} onCollapse={ onCollapse }>
                    <div className="logo"/>
                    <Menu theme="dark" defaultSelectedKeys={['0']} mode="inline">

                        {/* menú para los exámenes */}
                        { elegirSubmenu() }

                    </Menu>
                </Sider>

                <Layout className="site-layout">

                    <Header className="site-layout-background" style={{ padding: 0, display: 'flex', justifyContent: 'flex-end' }}>

                        <Menu mode="horizontal">
                            <Menu.SubMenu key="SubMenu" title="Opciones" icon={<SettingOutlined />}>
                                <Menu.Item key="salir" icon={<LogoutOutlined />} onClick={ () => window.location = '/login' }>
                                    Salir
                                </Menu.Item>
                            </Menu.SubMenu>
                        </Menu>

                    </Header>

                    <Content style={{ margin: '0 16px' }}>
                        {/* <Breadcrumb style={{ margin: '16px 0' }}>
                            <Breadcrumb.Item>User</Breadcrumb.Item>
                            <Breadcrumb.Item>Bill</Breadcrumb.Item>
                        </Breadcrumb> */}

                        <div style={{ height: 20 }}/>

                        <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                            { componente }
                        </div>
                    </Content>
                    <Footer style={{ textAlign: 'center' }} className='no-select'>Universidad Tecnológica de Escuinapa ©2022</Footer>
                </Layout>
            </Layout>
            <Toaster/>
        </>
    );
}

export default MenuPrincipal
